export const RefundPolicy = () => {
  return (
    <div>
      <p>Актуальная редакция: 24 июня 2025 г.</p>
      <h3 class="header-h3">Политика возврата</h3>
      <p>
        Компания GravizApp гарантирует возврат средств своим клиентам на
        следующих условиях:
      </p>
      <ul>
        <li>
          пользователь обратился за возвратом средств в течение 7 дней после
          совершения покупки
        </li>
        <li>
          возможность возврата предоставляется пользователю только один раз
        </li>
        <li>
          отсутствие жалоб на действия пользователя и нарушений им правил
          использования сервиса
        </li>
        <li>
          возврат не распространяется на приобретенные пользователем выделенные
          IP-адреса
        </li>
        <li>
          возврат производится за вычетом комиссии платежной системы за
          совершение платежа
        </li>
        <li>
          возврат платежей, совершенных в криптовалюте, производится с
          пересчетом по текущему рыночному курсу
        </li>
        <li>
          мы оставляем за собой преимущественное право выбора способа и
          платежной системы для возврата платежа
        </li>
      </ul>
      <h3 class="header-h3">Как оформить возврат</h3>
      <p>
        Для получения возврата средств пользователю необходимо оформить заявку
        на странице обратной связи, указав:
      </p>
      <ul>
        <li>в теме сообщения — "Возврат средств"</li>
        <li>рабочую электронную почту для контакта</li>
        <li>
          в свободной форме сообщить причину возврата и предпочитаемый способ
          получения средств
        </li>
      </ul>
      <p>
        После получения заявки мы свяжемся с Вами для уточнения деталей завки.
        Возврат средств производится в следующие сроки:
      </p>
      <ul>
        <li>электронные платежи, мобильная коммерция — 7–14 дней</li>
        <li>
          банковские карты — 14–30 дней (зависит от скорости обработки запроса
          вашим банком)
        </li>
      </ul>
      <p>
        Мы надеемся, что наши услуги Вам понравятся. Но если что то пошло не
        так, и вам не подошло наше решение — мы вернем вам деньги без лишних
        формальностей.
      </p>
    </div>
  );
};

export const TermsOfService = () => {
  return (
    <div>
      <p>Актуальная редакция: 02 апреля 2026 г.</p>
      <h3 class="header-h3">Пользовательское соглашение</h3>
      <h3 class="header-h3">1. Общие положения</h3>
      <p>
        1.1. Настоящее Пользовательское соглашение (далее - «Соглашение»)
        регулирует порядок использования онлайн-сервиса (далее - «Сервис»),
        предоставляемого Администрацией.
      </p>
      <p>
        1.2. Используя Сервис, включая запуск бота, регистрацию, оплату услуг
        или получение доступа к материалам, Пользователь подтверждает, что
        полностью ознакомился с условиями настоящего Соглашения и принимает их в
        полном объеме.
      </p>
      <p>
        1.3. В случае несогласия с условиями Соглашения Пользователь обязан
        прекратить использование Сервиса.
      </p>
      <h3 class="header-h3">2. Характер услуг и цифровых товаров</h3>
      <p>
        2.1. Сервис предоставляет цифровые товары и услуги нематериального
        характера, включая, но не ограничиваясь: информационные материалы,
        обучающие программы, консультации, цифровые продукты и сервисные услуги.
      </p>
      <p>2.2. Материалы, предоставляемые через Сервис, могут включать:</p>
      <ul>
        <li>информацию из открытых источников;</li>
        <li>авторские материалы Администрации и/или третьих лиц;</li>
        <li>
          аналитические обзоры, подборки, рекомендации, структурированные данные.
        </li>
      </ul>
      <p>
        2.3. Пользователь осознает и соглашается, что ценность цифровых товаров и
        услуг Сервиса заключается в систематизации, анализе, форме подачи,
        сопровождении, поддержке и обновлениях, а не в эксклюзивности отдельных
        фрагментов информации.
      </p>
      <p>
        2.4. Сервис не заявляет и не гарантирует уникальность, исключительность
        или недоступность отдельных элементов материалов вне Сервиса.
      </p>
      <h3 class="header-h3">3. Отказ от гарантий и ответственности</h3>
      <p>3.1. Сервис предоставляется на условиях «AS IS» («как есть»).</p>
      <p>3.2. Администрация не гарантирует:</p>
      <ul>
        <li>соответствие Сервиса ожиданиям Пользователя;</li>
        <li>
          достижение каких-либо финансовых, коммерческих, профессиональных или
          иных результатов;
        </li>
        <li>бесперебойную и безошибочную работу Сервиса.</li>
      </ul>
      <p>3.3. Администрация не несет ответственности за:</p>
      <ul>
        <li>любые прямые или косвенные убытки, включая упущенную выгоду;</li>
        <li>последствия применения Пользователем полученных материалов;</li>
        <li>действия или бездействие третьих лиц;</li>
        <li>временные технические сбои и ограничения доступа.</li>
      </ul>
      <p>
        3.4. Все решения о применении материалов, рекомендаций и услуг
        принимаются Пользователем самостоятельно и на его риск.
      </p>
      <h3 class="header-h3">4. Законность использования</h3>
      <p>
        4.1. Сервис не предназначен для поощрения, организации или содействия
        противоправной деятельности.
      </p>
      <p>
        4.2. Пользователь обязуется использовать Сервис исключительно в рамках
        применимого законодательства и правил третьих сторон.
      </p>
      <p>
        4.3. Ответственность за законность использования материалов и услуг
        Сервиса полностью возлагается на Пользователя.
      </p>
      <h3 class="header-h3">5. Интеллектуальная собственность</h3>
      <p>
        5.1. Все материалы, размещенные в Сервисе, охраняются законодательством
        об интеллектуальной собственности.
      </p>
      <p>
        5.2. Пользователю запрещается копировать, распространять, перепродавать,
        передавать третьим лицам или иным образом использовать материалы Сервиса
        без разрешения правообладателя.
      </p>
      <p>
        5.3. Нарушение прав интеллектуальной собственности может повлечь
        ограничение доступа к Сервису без компенсации.
      </p>
      <h3 class="header-h3">6. Ограничение доступа</h3>
      <p>
        6.1. Администрация вправе приостановить или ограничить доступ
        Пользователя к Сервису в случае:
      </p>
      <ol>
        <li>нарушения условий настоящего Соглашения;</li>
        <li>выявления злоупотреблений;</li>
        <li>требований законодательства или платежных провайдеров.</li>
      </ol>
      <p>
        6.2. Ограничение доступа не освобождает Пользователя от обязательств,
        возникших ранее.
      </p>
      <p>
        6.3. Администрация оставляет за собой право отказывать в обслуживании
        Пользователям, чьи действия могут создавать повышенные риски для
        Сервиса, платежных провайдеров или третьих лиц.
      </p>
      <h3 class="header-h3">7. Платежи и возвраты</h3>
      <p>
        7.1. Оплата услуг и цифровых товаров производится на условиях, указанных
        в Сервисе до момента оплаты.
      </p>
      <p>
        7.2. В связи с нематериальным характером цифровых товаров и услуг,
        возврат денежных средств после предоставления доступа не осуществляется,
        за исключением случаев, указанных ниже.
      </p>
      <p>7.3. Возврат средств возможен только если:</p>
      <ul>
        <li>услуга не была оказана по технической вине Сервиса;</li>
        <li>доступ к цифровому товару фактически не был предоставлен.</li>
      </ul>
      <p>
        7.4. Для рассмотрения вопроса о возврате Пользователь обязан обратиться
        в службу поддержки в течение 24 часов с момента оплаты.
      </p>
      <p>7.5. Решение о возврате принимается Администрацией индивидуально.</p>
      <p>
        7.6. Пользователь подтверждает, что обязуется не инициировать возврат
        платежа (chargeback) через платежные системы без предварительного
        обращения в службу поддержки Сервиса.
      </p>
      <h3 class="header-h3">8. Конфиденциальность</h3>
      <p>
        8.1. Администрация может собирать минимально необходимые технические
        данные для обеспечения работы Сервиса.
      </p>
      <p>
        8.2. Администрация принимает разумные меры для защиты данных, однако не
        гарантирует абсолютную безопасность передаваемой информации.
      </p>
      <h3 class="header-h3">9. Изменение условий</h3>
      <p>9.1. Администрация вправе вносить изменения в настоящее Соглашение.</p>
      <p>9.2. Актуальная версия Соглашения публикуется в Сервисе.</p>
      <p>
        9.3. Продолжение использования Сервиса означает согласие Пользователя с
        обновленными условиями.
      </p>
      <h3 class="header-h3">10. Контактная информация</h3>
      <p>
        10.1. По всем вопросам Пользователь может обратиться в службу поддержки
        через форму в самом боте.
      </p>
      <p>
        Используя Сервис (в том числе запуская бота и/или вводя команду /start),
        Пользователь подтверждает, что ознакомлен с настоящим Соглашением и
        принимает его условия в полном объеме.
      </p>
    </div>
  );
};

export const PrivacyPolicy = () => {
  return (
    <div>
      <p>Актуальная редакция: 15 октября 2026 г.</p>
      <h3 class="header-h3">Политика конфиденциальности</h3>
      <p>
        Политика конфиденциальности регулирует сбор, использование и защиту
        информации пользователей сервиса.
      </p>
      <p>
        Собираются идентификаторы аккаунта, техническая информация и история
        взаимодействий. Данные используются для обеспечения работы сервиса, связи
        с пользователем и анализа.
      </p>
      <p>
        Передача информации третьим лицам возможна только в законодательно
        установленных случаях или с согласия пользователя.
      </p>
      <p>
        Хранение данных осуществляется в течение необходимого срока, их защита -
        в разумных пределах. Пользователь самостоятельно несет ответственность за
        риски, связанные с передачей данных.
      </p>
      <p>
        Администрация вправе вносить изменения в Политику без уведомления -
        согласие считается принятым при дальнейшем использовании сервиса.
      </p>
      <h3 class="header-h3">1. Общие положения</h3>
      <p>
        1.1. Настоящая Политика конфиденциальности (далее - «Политика»)
        регулирует порядок обработки и защиты информации, которую Пользователь
        передает при использовании сервиса (далее - «Сервис»).
      </p>
      <p>
        1.2. Используя Сервис, Пользователь подтверждает свое согласие с
        условиями Политики. Если Пользователь не согласен с условиями - он
        обязан прекратить использование Сервиса.
      </p>
      <h3 class="header-h3">2. Сбор информации</h3>
      <p>2.1. Сервис может собирать следующие типы данных:</p>
      <ul>
        <li>идентификаторы аккаунта (email, telegramID);</li>
        <li>
          техническую информацию (настройки аккаунта, зашифрованный стойким криптографическим алгоритмом пароль, учетные данные подписок, баланс средств на лицевом счете и т.п.);
        </li>
        <li>историю взаимодействий с Сервисом (сведения о приобретенных подписках, дата и время платежа).</li>
      </ul>
      <p>
        2.2. Сервис не требует от Пользователя предоставления паспортных данных,
        документов, фотографий или другой личной информации.
      </p>
      <p>
        2.3. Сервис не собирает и не хранит IP-адреса Пользователей, также как не ведет записей об адресах посещаемых ими ресурсах, полученных и переданных данных и т.п. На серверах Сервиса не содержатся какие-либо записи либо лог-файлы, которые позволят ассоциировать любую активность с конкретным Пользователем.
      </p>
      <h3 class="header-h3">3. Использование информации</h3>
      <p>3.1. Сервис может использовать полученную информацию исключительно для:</p>
      <ul>
        <li>обеспечения работы функционала;</li>
        <li>
          связи с Пользователем (в том числе для уведомлений и поддержки);
        </li>
        <li>анализа и улучшения работы Сервиса.</li>
      </ul>
      <h3 class="header-h3">4. Передача информации третьим лицам</h3>
      <p>
        4.1. Администрация не передает полученные данные третьим лицам, за
        исключением случаев:
      </p>
      <ul>
        <li>если это требуется по закону;</li>
        <li>
          если это необходимо для исполнения обязательств перед Пользователем
          (например, при работе с платежными системами);
        </li>
        <li>если Пользователь сам дал на это согласие.</li>
      </ul>
      <h3 class="header-h3">5. Хранение и защита данных</h3>
      <p>
        5.1. Данные хранятся в течение срока, необходимого для достижения целей
        обработки.
      </p>
      <p>
        5.2. Администрация принимает разумные меры для защиты данных. Собираемые данные являются коммерческой тайной, находятся на выделенном сервере, доступ к которому, в том числе техническое обслуживание, имеют исключительно сотрудники Сервиса.
      </p>
      <h3 class="header-h3">6. Отказ от ответственности</h3>
      <p>
        6.1. Администрация не несет ответственности за утрату, кражу или
        раскрытие данных, если это произошло по вине третьих лиц или самого
        Пользователя.
      </p>
      <h3 class="header-h3">7. Изменения в Политике</h3>
      <p>
        7.1. Администрация вправе изменять условия Политики без предварительного
        уведомления.
      </p>
      <p>
        7.2. Продолжение использования Сервиса после внесения изменений означает
        согласие Пользователя с новой редакцией Политики.
      </p>
    </div>
  );
};

export default {
  RefundPolicy,
  TermsOfService,
  PrivacyPolicy,
};
